module.exports = __webpack_public_path__ + "assets/img/prevIcon.cd760707.svg";